import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { Popover, Button, Tooltip, Badge, Tabs } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useQueryUrlParams from 'src/hooks/useQueryUrlParams';
import ProductFinderQueryParams from 'src/types/ProductFinderQueryParams';
import PriceDistributionGraph from '../PriceDistributionGraph';
import SearchPanel from '../../ProductFinder/SearchPanel';
import CompetitorPriceAnalysis from '../CompetitorPriceAnalysis';
import routes from 'src/routes';
import CategoryPriceAnalysis from '../CategoryPriceAnalysis';
import { usePriceVarianceFetch, usePriceCollectedTimeFetch } from './hooks';
import CategoryVariancess from '../CategoryVariancess';
import Widget from 'src/components/common/Widget';
import CompetitorVariancess from '../CompetitorVariancess';
import ChangePasswordForm from 'src/components/SettingsPage/ChangePassword/ChangePasswordForm';
import { useChangePasswordPostFetch } from 'src/components/SettingsPage/hooks';
import Modal from 'src/components/common/Modal';
import OptionsFiltersSider from 'src/components/ProductFinder/OptionsFiltersSider';
import { useAppStateContext } from 'src/stateProviders/useAppStateContext';
import styles from '../CompetitorPriceAnalysis/CompetitorPriceAnalysis.module.less';

const { TabPane } = Tabs;

const QMDashboardView: React.FC = () => {
  const [{ data: priceVariance, loading }] = usePriceVarianceFetch();
  const [{ data: priceCollectedTime }] = usePriceCollectedTimeFetch();
  const [collapsed, setCollapsed] = useState(true);
  const [collapsedOptions, setCollapsedOptions] = useState(true);
  const [openClose, setOpenClose] = useState(true);
  const [selectedOptionsCount, setSelectedOptionsCount] = useState(0);
  const content = (
    <div>
      <p>Collection Date: {priceCollectedTime?.priceCollectedTimestamp}</p>
    </div>
  );
  const { defaultSourceOwnerId } = useAppStateContext();
  const { sourceOwnerId } = useQueryUrlParams<ProductFinderQueryParams>();

  useEffect(() => {
    if (defaultSourceOwnerId || sourceOwnerId) {
      localStorage.setItem('sourceOwnerId', sourceOwnerId || defaultSourceOwnerId);
    }
  }, [defaultSourceOwnerId]);

  const openCloseFunction = () => {
    if (openClose) {
      setCollapsed(true);
    }
    setOpenClose(!openClose);
    setCollapsedOptions(!openClose);
  };

  const forgetPassword = localStorage.getItem('changePasswordFlag');
  const [_, { updateChangePassword }] = useChangePasswordPostFetch();
  const panelStyles = collapsedOptions ? styles.withFilters : styles.withoutFilters;

  const [passwordChanged, setPasswordChanged] = useState(forgetPassword === 'true');
  const addUpdateNameSetting = (values: { ischangepasswordflag: boolean }): void => {
    if (updateChangePassword && values) {
      updateChangePassword(values);
      setPasswordChanged(false);
    }
  };

  return (
    <>
      <div className={styles.searchBardetailsPage}>
        <div className={clsx(styles.searchPanel, panelStyles)}>
          <SearchPanel pathname={routes.productFinder} ownerPathname={routes.qmatchDashboard} />
        </div>
        <div className={clsx(styles.openClose, panelStyles)}>
          <Badge count={selectedOptionsCount} className={clsx(collapsed && styles.collapsed)}>
            {collapsedOptions ? (
              <Button block={collapsedOptions} type="primary" onClick={openCloseFunction}>
                <span>
                  <FontAwesomeIcon icon={['far', 'chevron-right']} size={'lg'} />
                  <span>Options</span>
                </span>
              </Button>
            ) : (
              <Tooltip placement="topLeft" title="Options">
                <Button block={collapsedOptions} type="primary" onClick={openCloseFunction}>
                  <span>
                    <FontAwesomeIcon icon={['far', 'sliders-h']} size={'lg'} />
                    <span>Options</span>
                  </span>
                </Button>
              </Tooltip>
            )}
          </Badge>
        </div>
      </div>
      <div className={styles.mainContainer}>
        <div className={styles.productListContainer}>
          <PriceDistributionGraph
            content={
              priceCollectedTime?.priceCollectedTimestamp
                ? `Collection Date: ${priceCollectedTime.priceCollectedTimestamp}`
                : ''
            }
          />
          <Widget title={'Competitor Price'}>
            <Popover placement="left" content={content}>
              <Button type="link" className={styles.button}>
                <FontAwesomeIcon icon={['fal', 'info-circle']} />
              </Button>
            </Popover>
            <Tabs tabPosition="top" className={styles.tabs}>
              <TabPane tab="Distribution" key="1">
                <CompetitorPriceAnalysis priceVariance={priceVariance} loading={loading} />
              </TabPane>
              <TabPane tab="Variance" key="2">
                <CompetitorVariancess variancess={priceVariance} loading={loading} />
              </TabPane>
            </Tabs>
          </Widget>
          <Widget title={'Category Analysis'}>
            <Popover placement="left" content={content}>
              <Button type="link" className={styles.button}>
                <FontAwesomeIcon icon={['fal', 'info-circle']} />
              </Button>
            </Popover>
            <Tabs tabPosition="top" className={styles.tabs}>
              <TabPane tab="Distribution" key="1">
                <CategoryPriceAnalysis priceVariance={priceVariance} loading={loading} />
              </TabPane>
              <TabPane tab="Variance" key="2">
                <CategoryVariancess variancess={priceVariance} loading={loading} />
              </TabPane>
            </Tabs>
          </Widget>
        </div>
        {openClose && (
          <OptionsFiltersSider collapsedOptions={collapsedOptions} onSelectedOptionsCount={setSelectedOptionsCount} />
        )}
      </div>
      <Modal
        title="Change Password"
        visible={passwordChanged}
        footer={null}
        className={styles.changePasswordPopOver}
        closable={false}
      >
        <ChangePasswordForm onUpdate={addUpdateNameSetting} />
      </Modal>
    </>
  );
};
export default QMDashboardView;
